import { useState } from 'react';
import { motion } from "framer-motion";
import { Container, Row, Col, Form, Table } from "react-bootstrap";

import question1_image from "../../../images/EmoAISession3Q1.png"
import question2_image from "../../../images/EmoAISession3Q2.png"
import question3_image from "../../../images/EmoAISession3Q3.png"
import question4_image from "../../../images/EmoAISession3Q4.png"
import ai_analysis from "../../../images/Emotion_analysis.png";
import discussion from "../../../images/discussion.png";
import ai_thinking from "../../../images/AI_thinking.png";
import ai_idea from "../../../images/ai_idea.png";
import ai_welcome from "../../../images/Welcome_ai.png";
import emoai_study from "../../../images/emoai_study.png";



export default function StudyTwoInstructionSessionThree2( {onSubmit} ){
    const options = ['Happy', 'Sad', 'Angry', 'Surprise', 'Neutral','Disgust','contempt','Fear'];
    const [selectedAnswers, setSelectedAnswers] = useState({
        question1: '',
        question2: '',
        question3: '',
        question4: ''
    });
    const correctAnswers = {
        question1: 'Happy',
        question2: 'Sad',
        question3: 'Angry',
        question4: 'Surprise'
    };

    const [submitted, setSubmitted] = useState(false);
    const handleSelectChange = (questionKey, event) => {
        setSelectedAnswers({
            ...selectedAnswers,
            [questionKey]: event.target.value
        });
    };
    const handleSubmit = () => {
        setSubmitted(true);

        if(onSubmit){
            onSubmit();
        }
    };
    const [showBubble, setShowBubble] = useState(false);

    const handleImageClick = () => {
        setShowBubble(true);
    }
    const allAnswered = Object.values(selectedAnswers).every(answer => answer !== '');
    return (
        <Container className="study-item" style={{width:"90%"}}>
            <br />
            <Row>
            <h1 className="subtitle">How about the dataset for EAI?</h1>
                <Container>

                {/* <h4 className="highlight">Congratulation! You already finished two sessions<i className='bx bx-smile'/></h4> */}
                {/* <p>Computer scientists think that more diverse databases 
                    (including various ethnicities, genders, different angles of faces, etc.) 
                    can improve potential biases in models. </p> 
                <p>However, can we truly achieve a fair dataset?</p> */}
                <br /><br />
                        <Row className="align-items-start mb-4">
                        <Col xs={4} className="text-center">
                            <img 
                                src={emoai_study} 
                                alt="FEAI icon" 
                                style={{ width: "150px", height: "150px", }} 
                            />
                        </Col>
                        <Col xs={7}>

                        <div className="chat-bubble">
                            <p>
                            These pictures are from my(FEAI's) dataset.                 
                            </p>
                        </div>
                        </Col>
                        </Row> 
                {!submitted ? (
                        <>

                            <h5>Here are four images. Please select the primary emotion category for each.</h5>

                            <br />
                            <Row>
                                {[question1_image, question2_image, question3_image, question4_image].map((image_src, questionNumber) => (
                                    <Col key={`question${questionNumber+1}`} md={3} className="text-center">
                                        <img
                                            style={{ width: '80%' }}
                                            src={image_src} 
                                            alt={`Question ${questionNumber+1}`}
                                        />
                                        <p>Question {questionNumber + 1}</p>
                                        <Form.Group controlId={`emotionSelect${questionNumber+1}`}>
                                            <Form.Control
                                                as="select"
                                                value={selectedAnswers[`question${questionNumber+1}`]}
                                                onChange={(e) => handleSelectChange(`question${questionNumber+1}`, e)}
                                                className="form-select mt-3"
                                                style={{width:'100%'}}
                                            >
                                                <option value="">Select emotion</option>
                                                {options.map(option => (
                                                    <option key={option} value={option}>{option}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                ))}
                            </Row>
                            <div className="text-center mt-4">
                                <motion.button
                                    type="button"
                                    className={`button carousel-button ${allAnswered ? '' : 'button-disabled'}`}
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.8 }}
                                    onClick={handleSubmit}
                                    disabled={!allAnswered}
                                >
                                    Submit
                                </motion.button>
                            </div>
                        </>
                    ) : (
                        <Row className="align-items-start mb-4">
                        <Col xs={4} className="text-center">
                            <img 
                                src={ai_thinking} 
                                alt="FEAI icon" 
                                style={{ width: "150px", height: "150px", }} 
                                onClick={handleImageClick}
                            />
                        </Col>
                        <Col xs={7}>
                        <div className="chat-bubble">
                            <p>
                            Did everyone give the same answer to each picture?
                            </p>
                            {showBubble && (<p>There is no single ground truth for emotion.</p>)}
                        </div>
                        </Col>
                    </Row> 
                    )}
                    <br />
                {submitted && (
                    <div>
                        <h4>Summary</h4> 
                        <div className="mt-3" style={{textAlign:'center'}}>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <td></td>
                                        <th><img src={question1_image} style={{width:'40%'}} alt="question_one" /></th>
                                        <th><img src={question2_image} style={{width:'40%'}} alt="question_two" /></th>
                                        <th><img src={question3_image} style={{width:'40%'}} alt="question_three" /></th>
                                        <th><img src={question4_image} style={{width:'40%'}} alt="question_four" /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><strong>Answers</strong></td>
                                        {Object.keys(selectedAnswers).map((questionKey) => (
                                            <td key={questionKey}>{selectedAnswers[questionKey]}</td>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td><strong className='highlight'>Labels</strong></td>
                                        {Object.keys(correctAnswers).map((questionKey) => (
                                            <td key={questionKey}>{correctAnswers[questionKey]}</td>
                                        ))}
                                    </tr>
                                </tbody>
                            </Table>
                            {/* <Row>
                            <table className="study-steps-table">
                            <thead>
                                <tr>
                                    <th>Key Words</th>
                                    <th>Explanation</th>
                                </tr>
                            </thead>
                            <tbody>
                                    <tr >
                                        <td>Labels</td>
                                        <td>Emotion categories provided by people for the images in the dataset. 
                                            The AI learns from these descriptions to recognize facial expressions 
                                            and distinguish human emotions based on facial features.</td>   
                                    </tr>
                            </tbody>
                        </table>  
                            </Row> */}
                        </div>
                        {/* <p>Labels are the descriptions provided by people for the images in the dataset. 
                            The AI learns from these descriptions to recognize facial expressions and distinguish human emotions based on facial features.</p>
                        <p>However, even with the same image, different people may have different opinions.</p> */}
                    </div>
                    )}
                </Container>
            </Row>
        </Container>
    );
};